import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
export const fetchDataLakeConnectorById = async (id) => fetch(
  "GET",
  qualifyUrl(`/plugins/org.graylog.plugins.datalake.externaldatalake.datasources.athena/athena/credentials/${id}`)
);
const useDataLakeConnectorById = (id) => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: ["data-lake-connector-by-id", id],
    queryFn: () => defaultOnError(
      fetchDataLakeConnectorById(id),
      i18n.t("notifications.fetch_connector_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_connector_failed_title", { ns: "enterprise_data_lake" })
    ),
    notifyOnChangeProps: ["data", "error"],
    enabled: !!id
  });
  return {
    data,
    refetch,
    isLoading,
    error
  };
};
export default useDataLakeConnectorById;
